import React from 'react';
import setTitle from 'src/utils/setTitle';

const HelpCases = () => {
  setTitle('ITSM | Help - Tickets');
  return (
    <>
      <h1>Tickets</h1>
      <img src="/static/help/cases.png" alt="Tickets View" />
      <p>
        The tickets module is where all the action happens. It contains a list of
        all the tickets that have been created for your projects. You can view all
        necessary information about the tickets in the main page:
      </p>
      <ol>
        <li>
          <strong>Ticket No: </strong>
          Unique ID for the ticket, naming convention starts with ticket type
          followed by numeric value
        </li>
        <li>
          <strong>Title: </strong>
          Title explaining more information about the ticket
        </li>
        <li>
          <strong>Reporter: </strong>
          Name/ID of person who created the ticket
        </li>
        <li>
          <strong>Assignee: </strong>
          Name/ID of person who is working on the ticket
        </li>
        <li>
          <strong>Type: </strong>
          Refers to the type of ticket
        </li>
        <li>
          <strong>Priority: </strong>
          Severity of the request
        </li>
        <li>
          <strong>Status: </strong>
          The current state of the ticket
        </li>
      </ol>

      <h2>Ticket Types</h2>
      <ol>
        <li>
          <strong>General Support</strong>
          <p>
            Caters to your general requests regarding applications, services
          </p>
        </li>
        <li>
          <strong>Redhat Support</strong>
          <p>Tickets related to Redhat products</p>
        </li>
        <li>
          <strong>Administrative</strong>
          <p>Tickets regarding administrative tasks</p>
        </li>
        <li>
          <strong>Application Support</strong>
          <p>Tickets for one of the IT22 application support</p>
        </li>
        <li>
          <strong>Application Bug</strong>
          <p>Tickets related to bugs in IT22 applications</p>
        </li>
        <li>
          <strong>Application Feature Request</strong>
          <p>
            Tickets regarding any feature you would like to see in IT22
            applications
          </p>
        </li>
      </ol>
    </>
  );
};

export default HelpCases;
